import "../css/style.scss";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { faGripLines, faQuestionCircle, faXmark, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import { faBluesky, faMastodon } from "@fortawesome/free-brands-svg-icons";

export default function NavBar({ content }) {
  const [opened, setOpened] = useState(false);
  const [hidden, setHidden] = useState(true);
  const buttonList = [
    {
      iconName: faEnvelope,
      onClick: () => {
        window.open("mailto:" + content.email);
      },
      tooltipText: "Email",
    },
    {
      iconName: faBluesky,
      onClick: () => {
        window.open(content.bluesky, "_blank");
      },
      tooltipText: "Blue Sky",
    },
    {
      iconName: faMastodon,
      onClick: () => {
        window.open(content.mastodon, "_blank");
      },
      tooltipText: "Mastodon",
    },
    // {
    //   iconName: faQuestionCircle,
    //   onClick: () => {
    //     window.open("google.com", "_blank");
    //   },
    //   tooltipText: "About",
    // },
  ];
  const toggle = () => {
    if (opened) {
      setTimeout(setHidden, 300, true);
      setOpened(false);
    } else {
      setTimeout(setOpened, 100, true);
      setHidden(false);
    }
  };

  const getButtonHeight = () => {
    if (opened) {
      return (buttonList.length + 1) * 3 + "rem";
    }
    return "3rem";
  };

  const getTransitionDelay = (i) => {
    if (opened) {
      return 0.05 + i * 0.1 + "s";
    }

    return (buttonList.length - i) * 0.05 + "s";
  };

  const letsTalk = () => {
    window.open("mailto:" + content.email);
  };

  return (
    <div className="navbar">
      <div className="logo">
        <img src={content.logoSrc} alt="Air Guslar Logo" />
      </div>
      <div className="name">Air Guslar</div>
      <div className="contact-btn" onClick={letsTalk}>
        Let's talk
      </div>
      <div className="nav-btn" style={{ height: getButtonHeight(), transitionDelay: opened ? "0s" : "0.2s" }}>
        <div>
          <div className="container">
            <div className="main-icon-bg " onClick={toggle}>
              <FontAwesomeIcon
                className="main-icon"
                icon={faGripLines}
                style={{
                  opacity: opened ? "0" : "1",
                  transform: opened ? "translate (-50%, -50%) rotate(90deg)" : "translate (-50%, -50%) rotate(0)",
                }}
              />
              <FontAwesomeIcon
                className="main-icon"
                icon={faXmark}
                style={{
                  opacity: opened ? "1" : "0",
                  transform: opened ? "translate(-50%, -50%) rotate(0)" : "translate(-50%, -50%) rotate(90deg)",
                }}
              />
            </div>
            {!hidden &&
              buttonList.map((item, i) => (
                <div
                  data-tooltip-id={"tooltip" + i}
                  key={i}
                  className="icon-bg"
                  onClick={() => {
                    buttonList[i].onClick();
                  }}
                  style={{
                    opacity: opened ? "1" : "0",
                    transitionDelay: getTransitionDelay(i),
                  }}
                >
                  <FontAwesomeIcon className="icon" icon={buttonList[i].iconName} />
                  <ReactTooltip
                    id={"tooltip" + i}
                    className="tooltip"
                    place="left"
                    content={buttonList[i].tooltipText}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
